import { PractitionerAvailability } from '../../../core/model/practitionerAvailability';
import { Component, Input, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Referral } from '../../../core/model/referral';
import { ReferralsService } from '../../../referrals/referrals.service';

@Component({
  selector: 'app-referrals-edit',
  templateUrl: './referrals-edit.component.html',
  styleUrls: ['./referrals-edit.component.scss']
})
export class ReferralsEditComponent implements OnInit {
  constructor(
    private referralService: ReferralsService,
    public dialogRef: MatDialogRef<ReferralsEditComponent>,
    @Inject(MAT_DIALOG_DATA) public referral: Referral) {
    if (referral.practitionerAvailability.length) {
      const selectedTime = referral.practitionerAvailability.find(x => x.selectedByUser);
      if (selectedTime) {
        this.selectedAppointmentTime = selectedTime.appointmentDate;
      }
    }
  }

  @Input() patientId: number;
  newAppointmentDate: Date;
  newAppointmentTime: string;
  selectedAppointmentTime: Date;
  availableTimes: any;
  minDate: Date;

  ngOnInit() {
    this.availableTimes = this.getTimeOptions();
    this.minDate = new Date();
    // If there is a patient availability record then use that as the initial value; otherwise use the current date
    let newDate = new Date();
    let newIsMorning = true;
    if (this.referral.patientAvailability && this.referral.patientAvailability.length > 0) {
      newDate = this.referral.patientAvailability[0].date;
      newIsMorning = this.referral.patientAvailability[0].isMorning;
    }
    // const appointmentDate: PatientAvailability = ((this.referral.patientAvailability) && (this.referral.patientAvailability.length > 0))
    //   ? this.referral.patientAvailability[0]
    //   : { date: new Date(), isMorning: true };

    // Adjust for missing time zone
    this.newAppointmentDate = new Date(new Date(newDate).getTime() + (new Date().getTimezoneOffset() * 60000));
    this.newAppointmentTime = newIsMorning ? "6:00" : "13:00";
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  addPractitionerAvailability() {
    if (!this.newAppointmentDate || !this.newAppointmentTime) {
      return;
    }

    const time = this.newAppointmentTime.substring(0, 5).split(':');
    const hours = +time[0] + (this.newAppointmentTime.indexOf('PM') === -1 ? 0 : 12);
    const minutes = +time[1];
    this.newAppointmentDate.setHours(hours, minutes, 0);

    this.referral.practitionerAvailability.push({
      referralId: this.referral.id,
      appointmentDate: this.newAppointmentDate,
      practitionerID: this.referral.practitioner.id,
      id: 0,
      selectedByUser: false
    });
    this.newAppointmentDate = null;
    this.newAppointmentTime = null;
    this.updateReferral();
  }

  removePractitionerAvailability(availability: PractitionerAvailability, event) {
    event.stopPropagation();
    const idx = this.referral.practitionerAvailability.indexOf(availability);
    if (idx !== -1) {
      this.referral.practitionerAvailability.splice(idx, 1);
    }
    this.updateReferral();
  }

  confirmAppointment() {
    if (this.referral.appointmentDate === this.selectedAppointmentTime) {
      this.referral.appointmentDate = null;
    } else {
      this.referral.appointmentDate = this.selectedAppointmentTime;
    }
    this.updateReferral();
  }

  close() {
    this.dialogRef.close();
  }

  updateReferral() {
    this.referralService.updateAvailability(this.referral).subscribe(
      (referral) => { this.referral.status = referral.status; },
      (error) => { console.error(error); });
  }

  getTimeOptions() {
    var options = [];
    var hours, minutes, ampm;
    for (var i = 0 * 60; i <= 24 * 60 - 1; i += 15) {
      hours = Math.floor(i / 60);
      minutes = i % 60;
      if (minutes < 10) {
        minutes = '0' + minutes; // adding leading zero
      }

      var timeOption = { value: hours + ":" + minutes, viewValue: '' };

      ampm = hours % 24 < 12 ? 'AM' : 'PM';
      hours = hours % 12;
      if (hours === 0) {
        hours = 12;
      }

      timeOption.viewValue = hours + ":" + minutes + ' ' + ampm;

      options.push(timeOption);
    }

    return options;
  }
}
